export { default } from './Checkbox';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Checkbox/index.jsx